import React from "react";
import {
  DialogContent,
  Card,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import Colors from "shared/color";
import TableBodyCell from "components/table/TableBodyCell";
//icons
import { nullToDash, formatCurrency } from "shared/utils";
import { RobotFont } from "components/ui/RobotFont";
import { ROUTE_NAME, PERMISSIONS, ROUTES_VAR } from "shared/constants";
import KisshtLink from "components/ui/KisshtLink";

export const ViewMapping = ({ data, reason }) => {
  let mapping_type =
    reason === "FLIPKART_PAYMENT"
      ? "repayment_reference_number"
      : "mapping_type_reference_number";
  data = nullToDash(data);
  return (
    <DialogContent
      dividers={false}
      style={{
        backgroundColor: Colors["lighterPurple"],
        fontSize: "0.8125rem",
      }}
    >
      <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
        {data.length ? (
          <Card>
            <TableContainer className="common_X_scroll">
              <Table
                size="small"
                aria-label="simple table"
                style={{ width: "100.1%" }}
              >
                <TableHead style={{textTransform:"capitalize"}}>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Applied Amount</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Loan Reference No.</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>
                      Repayment Reference No.
                    </span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Dues Reference No.</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Mapping Type</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>
                      Applied Towards Principal
                    </span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>
                      Applied Towards Interest
                    </span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Applied Towards Dues</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span style={{ color: "#000" }}>Direction</span>
                  </TableBodyCell>
                  <TableBodyCell className="common_table_title">
                    <span>Created At</span>
                  </TableBodyCell>
                </TableHead>
                {data.map((data) => (
                  <TableBody>
                    <TableBodyCell className="common_table_content">{data["applied_amount"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <KisshtLink
                        to={`${ROUTES_VAR.loans}/${data["loan_reference_number"]}`}
                        permission={PERMISSIONS.payment.loan_view}
                        route={ROUTE_NAME.payment}
                        style={{ color: Colors.purple_400 }}
                      >
                        {data["loan_reference_number"]}
                      </KisshtLink>
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["mapping_type"] === "REPAYMENT"
                        ? data[mapping_type]
                        : "-"}
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["mapping_type"] === "DUES"
                        ? data[mapping_type]
                        : "-"}
                    </TableBodyCell>

                    <TableBodyCell className="common_table_content">{data["mapping_type"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">
                        {formatCurrency(data["applied_towards_principal"])}
                      </RobotFont>
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">
                        {formatCurrency(data["applied_towards_interest"])}
                      </RobotFont>
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">
                        {formatCurrency(data["applied_towards_dues"])}
                      </RobotFont>
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["direction"]}</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["created_at"]}</TableBodyCell>
                  </TableBody>
                ))}
              </Table>
            </TableContainer>
          </Card>
        ) : (
          <span className="text-center">No Mapping data</span>
        )}
      </div>
    </DialogContent>
  );
};
